import { render, staticRenderFns } from "./add-product-modal.vue?vue&type=template&id=38133a5c&scoped=true&"
import script from "./add-product-modal.vue?vue&type=script&lang=js&"
export * from "./add-product-modal.vue?vue&type=script&lang=js&"
import style0 from "./add-product-modal.vue?vue&type=style&index=0&id=38133a5c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38133a5c",
  null
  
)

export default component.exports